import SearchBar from '@/components/features/Search/SearchBar';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import { useDebounce } from 'react-use';

type Props = {
  initialSearchQuery?: string;
  onSearchQueryChange?: (query: string) => void;
};

export const DebouncedSearchBar = ({ initialSearchQuery, onSearchQueryChange }: Props) => {
  const { t } = useTranslation('search');
  const [searchQuery, setSearchQuery] = useState<string>('');

  useDebounce(() => onSearchQueryChange?.(searchQuery), 500, [searchQuery]);

  useEffect(() => {
    if (!initialSearchQuery) return;
    setSearchQuery(initialSearchQuery);
  }, [initialSearchQuery]);

  return (
    <SearchBar
      testId="results-filter"
      onChange={e => setSearchQuery(e.target.value)}
      placeholder={t('results-filter.placeholder')}
      value={searchQuery}
      onReset={() => setSearchQuery('')}
      variant="round"
    />
  );
};
